import { render, staticRenderFns } from "./financial-center.vue?vue&type=template&id=1512fe78&scoped=true"
import script from "./financial-center.vue?vue&type=script&lang=js"
export * from "./financial-center.vue?vue&type=script&lang=js"
import style0 from "./financial-center.vue?vue&type=style&index=0&id=1512fe78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512fe78",
  null
  
)

export default component.exports